module.exports = __webpack_public_path__ + "static/media/photo187.152a6ed6.jpg";